import React, {useEffect , useState} from 'react';
import Firebase from 'firebase';
import MainDiv from './main-div';
import './App.css';

function App() {
  const [jobList, setJobList] = useState([]);
  useEffect(()=>{
    let ref = Firebase.database().ref(`/jobs/`);
     ref.on('value', snapshot => {
     const jobs = snapshot.val();
     const jb = [];
     Object.keys(jobs).map(key =>  jb.push(jobs[key]));
      setJobList([...jb]);
       });
},[]);
  return (
    <div>
      <MainDiv jobList={jobList} />
    </div>
  );
}

export default App;
